// Hình học + hằng số dùng chung cho các mặt la bàn (Bát Trạch, khí ngày).
// Tách khỏi file component để hai mặt la bàn vẽ cùng một hệ toạ độ, và để
// HMR không phải reload cả cây component khi sửa mấy hàm toán này.

/** Tâm mặt la bàn trong viewBox 400×400. */
export const C = 200;

/** Góc (độ, 0 = Bắc, thuận chiều kim đồng hồ) + bán kính → toạ độ SVG. */
export function toXY(goc: number, r: number): [number, number] {
  const rad = ((goc - 90) * Math.PI) / 180;
  return [C + r * Math.cos(rad), C + r * Math.sin(rad)];
}

/** Hình quạt vành khuyên từ góc `a0` tới `a1`. */
export function vanhQuat(rNgoai: number, rTrong: number, a0: number, a1: number) {
  const [x1, y1] = toXY(a0, rNgoai);
  const [x2, y2] = toXY(a1, rNgoai);
  const [x3, y3] = toXY(a1, rTrong);
  const [x4, y4] = toXY(a0, rTrong);
  const lon = Math.abs(a1 - a0) > 180 ? 1 : 0;
  return `M ${x1} ${y1} A ${rNgoai} ${rNgoai} 0 ${lon} 1 ${x2} ${y2} L ${x3} ${y3} A ${rTrong} ${rTrong} 0 ${lon} 0 ${x4} ${y4} Z`;
}

/**
 * Đường dẫn cho chữ chạy vòng cung — luôn vẽ thuận chiều kim đồng hồ.
 *
 * KHÔNG lật chữ ở nửa dưới: mặt la bàn xoay liên tục nên nếu lật theo vị trí
 * thì mỗi lần một cung đi qua ranh giới, chữ sẽ đảo đột ngột (nhảy chữ). Để
 * chữ quay cùng mặt la bàn là cách la kinh thật vẫn làm, và không bao giờ nhảy.
 */
export function cungChu(r: number, goc: number, doRong: number) {
  const [xa, ya] = toXY(goc - doRong / 2, r);
  const [xb, yb] = toXY(goc + doRong / 2, r);
  return `M ${xa} ${ya} A ${r} ${r} 0 0 1 ${xb} ${yb}`;
}

/** Vì sao kim chưa chạy — nói rõ để người dùng biết cần làm gì. */
export const GHI_CHU_TRANG_THAI: Partial<Record<string, string>> = {
  "khong-ho-tro":
    "Thiết bị này không có cảm biến từ trường. Mở trên điện thoại để kim tự xoay theo hướng bạn đang đứng.",
  "khong-an-toan":
    "Trình duyệt chỉ cho đọc cảm biến khi trang chạy HTTPS. Hãy mở trang qua địa chỉ https:// rồi thử lại.",
  "khong-tin-hieu":
    "Không nhận được tín hiệu từ kế sau vài giây. Máy có thể thiếu la bàn, hoặc cần bật Chuyển động & Hướng trong cài đặt trình duyệt. Bạn vẫn có thể kéo mặt la bàn để tra hướng.",
  "tu-choi":
    "Bạn đã từ chối quyền truy cập cảm biến. Vào Cài đặt trình duyệt để bật lại Chuyển động & Hướng.",
};

/** Nền cung theo trục tốt/xấu, `dam` là độ đậm 0–1. */
export function mauNen(tot: boolean, dam: number) {
  const bien = tot ? "--element-wood" : "--element-fire";
  return `color-mix(in oklch, var(${bien}) ${Math.round(dam * 100)}%, transparent)`;
}

/** Nền cung theo biến CSS bất kỳ (dùng cho thang 3 mức của la bàn khí ngày). */
export function mauNenBien(bien: string, dam: number) {
  return `color-mix(in oklch, var(${bien}) ${Math.round(dam * 100)}%, transparent)`;
}
